module.exports = __webpack_public_path__ + "img/bold-icon checkbox-dropdown (1).44d6dd71.svg";